import type { MonitorUserFeature } from 'shared';

/** 只上报功能分类，不上传路径、查询参数或用户内容。 */
export function monitorFeature(routeName: string): MonitorUserFeature {
  if (routeName.includes('marketplace')) return 'marketplace';
  if (routeName.includes('settings') || routeName === 'workspace-management') return 'settings';
  if (routeName.includes('chat') || routeName.includes('agent-presentation')) return 'chat';
  if (routeName.includes('task')) return 'tasks';
  if (routeName === 'creative-center' || routeName === 'creative-create') return 'creative';
  if (routeName === 'account-files') return 'files';
  if (routeName === 'account-knowledge') return 'knowledge';
  if (routeName.includes('library')) return 'library';
  if (routeName.includes('component') || ['developer-workspace', 'app-runtime'].includes(routeName))
    return 'component';
  if (routeName.startsWith('workspace-')) return 'workspace';
  return 'other';
}
